import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DenunciasService } from 'src/app/services/denuncias.service';
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";


@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.css']
})
export class DetalleComponent implements OnInit {

  infoDenuncia: any;
  codigo: any;
  estados: any = [];
  resolucion: any;
  involucran : any = [];

  constructor(private denunciasService: DenunciasService,
              private route: ActivatedRoute,
              private spinner: NgxSpinnerService
              ) { }

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      this.codigo = params["id"];
      this.obtenerInvolucran();
      this.obtenerDatos(this.codigo);
      this.obtenerEstados();
    })
  }

  obtenerDatos(codigo: any) {
    this.spinner.show();
    this.denunciasService.obtenerDenuncia({ codigo: codigo }).subscribe({
      next: (data: any) => {
        this.spinner.hide();
        this.infoDenuncia = data;
        this.resolucion = this.infoDenuncia?.resolucion.resolucion;
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    })
  }

  obtenerEstados() {
    this.spinner.show();
    this.denunciasService.listarEstados().subscribe({
      next: (est: any) => {
        this.spinner.hide();
        this.estados = est;
        console.log(est);
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    })
  }

  formatoFecha(fecha: string): string {
    if (fecha) {
      fecha = fecha.replace('.000Z', '');
      return moment(fecha).format('DD/MM/YYYY');
    }

    return '';
  }

  async downloadFile(event: any) {
    console.log(event);
    const fileData = {
      key: event.ruta,
      metodo: 'get',
    }
    const url = await this.denunciasService.getSignedUrl(fileData).toPromise();
    window.open(url.message, "_blank")
  }

  obtenerEstado(event: any) {
    return event != null ? this.estados.find((est: any) => est.estId == event).nombre : '';
  }

  verPdf(event: any){
    const extencion = event.nombre.split(".").pop()
    return extencion == 'pdf' ? true :  false;
  }

 async obtenerPdf(event : any){
    const fileData = {
      key: event.ruta,
      metodo: 'get',
    }
    const url = await this.denunciasService.getSignedUrl(fileData).toPromise();
    window.open(url.message, '_blank');

  }
  
  obtenerInvolucran() {
    this.spinner.show();
    this.denunciasService.listarInvolucran().subscribe({
      next: (invo: any) => {
        this.spinner.hide();
        this.involucran = invo;
        console.log(invo);
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    })
  }

  showInvolucran(id : any){
    return id !== null ? this.involucran.find((invo: any) => invo.invoId == id).nombre : '';
  }
}
